import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import CompanyTab from "./printing/CompanyTab";
import ReceiptTab from "./printing/ReceiptTab";
import InvoiceTab from "./printing/InvoiceTab";
import FiscalTab from "./printing/FiscalTab";
import SetupGuide from "./printing/SetupGuide";

const TABS = [
  ["receipt", "Ресторантски принтер (80 мм)", ReceiptTab], ["invoice", "Хотелски принтер (A4)", InvoiceTab],
  ["company", "Данни на фирмата", CompanyTab], ["fiscal", "Фискално устройство", FiscalTab], ["guide", "Инструкции за инсталиране", SetupGuide],
];

export default function PrintSettings() {
  return (
    <div className="p-4 sm:p-6">
      <h1 className="font-display text-4xl text-forest-deep">Настройки за печат</h1>
      <div className="gold-rule w-24 my-4" />
      <Tabs defaultValue="receipt">
        <TabsList className="bg-cream-muted flex-wrap h-auto">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`print-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-4"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
